import React, { useState } from "react";
import { MoreVertical, Pin, Pencil, Share2, Trash2 } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu";
import ShareChatModal from "./ShareChatModal";
import { useUsersContext } from "../../../context/usersContext";
import RenameChatModal from "./RenameChatModal";
import { useUserInfo } from "../../../context/user";
import DeleteChatModal from "./DeleteChatModal";
import { useToggleFavouriteChat } from "../../../queries/chatActions";

const SidebarChatLink = ({ fav = true, item }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [userInfo, , , , userActiveLocation] = useUserInfo();
  const { openShareModal, setOpenShareModal, chatError, setChatError } =
    useUsersContext();
  const [openRenameModal, setOpenRenameModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { fetchChats } = useUsersContext();
  const { mutateAsync: toggleFavouriteChat } = useToggleFavouriteChat();

  const handleFavourite = async (e, chat) => {
    e.stopPropagation();
    e.preventDefault();
    const response = await toggleFavouriteChat({
      add: true,
      chatId: chat?.conversation_id,
      userId: userInfo?._id,
      locationId: userActiveLocation?.id,
    });
    if (response) {
      await fetchChats();
    }
  };

  const removeFromFav = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const response = await toggleFavouriteChat({
      add: false,
      chatId: item.conversation_id,
      userId: userInfo?._id,
      locationId: userActiveLocation?.id,
    });
    if (response) {
      await fetchChats();
    }
  };

  return (
    <div>
      <div
        onClick={() => {
          navigate(`/app/chat/${item.conversation_id}`);
          chatError?.showError &&
            setChatError({
              showError: false,
              errorMessage: "",
              classNames: "",
              iconColor: "",
            });
        }}
        className="cursor-pointer"
      >
        <div
          className={`flex mx-1.5 px-1.5 py-2 items-center my-1 rounded-md relative ${params.id && params.id === item.conversation_id ? "bg-sidebar-accent" : "bg-transparent hover:bg-sidebar-accent/60"}`}
        >
          {fav && (
            <button
              type="button"
              aria-label="Unpin conversation"
              onClick={(e) => removeFromFav(e)}
              className="flex items-center justify-center text-muted-foreground hover:text-foreground"
            >
              <Pin className="w-4 h-4" />
            </button>
          )}

          <div className="text-sm text-nowrap w-full truncate mx-4">{item.name}</div>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                type="button"
                aria-label="Conversation options"
                onClick={(e) => e.stopPropagation()}
                onPointerDown={(e) => e.stopPropagation()}
                className="flex items-center justify-center w-7 h-7 mr-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-accent"
              >
                <MoreVertical className="w-4 h-4" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-40">
              {!fav && (
                <DropdownMenuItem onSelect={(e) => handleFavourite(e, item)}>
                  <Pin className="w-4 h-4 mr-2" />
                  Pin
                </DropdownMenuItem>
              )}
              <DropdownMenuItem
                onSelect={(e) => {
                  e.stopPropagation();
                  setOpenRenameModal(true);
                }}
              >
                <Pencil className="w-4 h-4 mr-2" />
                Rename
              </DropdownMenuItem>
              <DropdownMenuItem
                onSelect={(e) => {
                  e.stopPropagation();
                  setOpenShareModal(item.conversation_id);
                }}
              >
                <Share2 className="w-4 h-4 mr-2" />
                Share
              </DropdownMenuItem>
              <DropdownMenuItem
                className="text-destructive focus:text-destructive"
                onSelect={(e) => {
                  e.stopPropagation();
                  setOpenDeleteModal(true);
                }}
              >
                <Trash2 className="w-4 h-4 mr-2" />
                Delete
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <ShareChatModal
        isOpen={openShareModal === item.conversation_id}
        onClose={() => setOpenShareModal(null)}
        chatTitle={item.name}
        contact={item.userId}
        id={item.conversation_id}
      />
      {openRenameModal && (
        <RenameChatModal
          isOpen={openRenameModal}
          onClose={() => setOpenRenameModal(false)}
          chatTitle={item.name}
          id={item.conversation_id}
        />
      )}
      {openDeleteModal && (
        <DeleteChatModal
          isOpen={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          id={item.conversation_id}
          fetchChats={fetchChats}
          navigateBack={item.conversation_id === params?.id}
        />
      )}
    </div>
  );
};

export default SidebarChatLink;
